






























import Vue from 'vue';
import Component from 'vue-class-component';
import User from './User.vue';
import cleanMessageBody from '../helpers/cleanMessageBody';
import dateFormat from '../helpers/dateFormat';

const TicketMessageProps = Vue.extend({
  props: {
    username: {
      type: String,
    },

    email: {
      type: String,
    },

    companyName: {
      type: String,
    },

    body: {
      type: String,
    },

    createdAt: {
      type: String,
    },

    toEmails: {
      type: Array as () => Array<string>,
    },

    ccEmails: {
      type: Array as () => Array<string>,
    },

    bccEmails: {
      type: Array as () => Array<string>,
    },

    styleType: {
      type: String,
    },

    avatar: {
      type: String,
    },
  },
});

@Component({
  name: 'TicketMessage',

  components: {
    User,
  },
})
export default class TicketMessage extends TicketMessageProps {
  get cleanBody() {
    return cleanMessageBody(this.body);
  }

  get createdAtFormatted() {
    return dateFormat(new Date(this.createdAt));
  }

  get toEmailsFormatted() {
    let emails: Array<string> = [];

    if (this.toEmails) {
      emails = emails.concat(this.toEmails);
    }

    if (this.ccEmails) {
      emails = emails.concat(this.ccEmails);
    }

    if (this.bccEmails) {
      emails = emails.concat(this.bccEmails);
    }

    return emails.length ? emails.join(', ') : null;
  }
}
